export const server_url = `${import.meta.env.VITE_API_BASE_URL}`;
